import React from 'react';
import './FullScreenIcon.scss';
import FullScreen from '../../../images/fullscreen.png';

const FullScreenIcon = () => {
  return <img src={FullScreen} className='full-screen-icon' alt='FullScreen' />;
};

export default FullScreenIcon;
